import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./App.css";
import "./index.css";

// Override document.title IMMEDIATELY before anything else
(function() {
  // Set title first
  document.title = "Everest Zoom";

  // Override the title property at the earliest possible moment

  Object.defineProperty(document, 'title', {
    get: function() {
      return "Everest Zoom";
    },
    set: function(_value) {
      const titleElement = document.querySelector('title');
      if (titleElement) {
        titleElement.textContent = "Everest Zoom";
      }
    },
    configurable: true
  });

  // Aggressive monitoring from the start
  setInterval(() => {
    const titleElement = document.querySelector('title');
    if (titleElement && titleElement.textContent !== "Everest Zoom") {
      titleElement.textContent = "Everest Zoom";
    }
  }, 10);
})();

// Handle Zoom container visibility
const path = window.location.pathname;
if (path !== "/zoom") {
  const zoomContainer = document.getElementById("zmmtg-root");
  if (zoomContainer) {
    (zoomContainer as HTMLElement).style.display = "none";
  }
} else {
  document.body.classList.add("zoom-meeting-active");
}
//fuck
// Function to hide Zoom controls
function hideZoomControls() {
  // Hide these specific buttons/elements
  const hideSelectors = [
    'div[footer-section="lef"]',
    '.meeting-info-container__wrapper',
    '.meeting-info-icon__icon-wrap',
    '.meeting-info-icon__button-wrap',
    '.attention-mode__icon',
    '.pop-panel__button-wrap',
    '#meeting-info-indication',
    '#app-signal',
    '.participants-section-container',
    '.preview-video__control-button',
    '.preview-audio-control-button',
    '.preview-video__control-button-container',
    '.preview-canvas',
    '.screen-share-button',
    '.whiteboard-button',
    '.annotation-button',
    '.anno-entrance-btn',
    '.anno-tools__item',
    '.anno-tools__btn',
    '[data-testid="screen-share-button"]',
    '[data-testid="whiteboard-button"]',
    '[data-testid="annotation-button"]',
    '[aria-label*="Share"]',
    '[aria-label*="Annotate"]',
    '[aria-label*="Whiteboard"]',
    '[aria-label*="Mute"]',
    '[aria-label*="Unmute"]',
    '[aria-label*="Start Video"]',
    '[aria-label*="Stop Video"]',
    'div[feature-type="microphone"]',
    'div[feature-type="camera"]',
    'div[feature-type="sharing"]',
    'div[feature-type="share"]',
    'div[feature-type="participant"]',
    'div[feature-type="aic"]',
    'div[feature-type="more"]',
    '.more-button',
    '.meeting-header',
    '.zoom-meetingsdk-meeting-header',
  ];

  hideSelectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => {
      (el as HTMLElement).style.display = 'none';
      (el as HTMLElement).style.visibility = 'hidden';
      (el as HTMLElement).style.pointerEvents = 'none';
    });
  });
}

// Apply control hiding when user is an attendee
if (path === "/zoom") {
  // Multiple attempts to hide controls as Zoom UI loads asynchronously
  setTimeout(hideZoomControls, 1000);
  setTimeout(hideZoomControls, 3000);
  setTimeout(hideZoomControls, 5000);

  // // Use MutationObserver to catch dynamically added controls and fix chat panel
  // window.addEventListener("DOMContentLoaded", () => {
  //   const observer = new MutationObserver(function (mutations) {
  //     let shouldHide = false;
  //     mutations.forEach(function (mutation) {
  //       if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
  //         shouldHide = true;
  //       }
  //     });
  //     if (shouldHide) {
  //       setTimeout(hideZoomControls, 100);
  //     }
  //   });

  //   observer.observe(document.body, {
  //     childList: true,
  //     subtree: true,
  //     attributes: true,
  //     attributeFilter: ['class', 'style']
  //   });
  // });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
